import React from 'react';
import { Panel } from 'react-bootstrap';
import PagedEntitiesList from '../../../common/components/PagedEntitiesList';
import { withTranslation } from 'react-i18next';
import ui from '../../../common/services/ui';

const Summary = ({ t, title, reportType, ...rest }) => {
	const columns = [
		{
			header: t(reportType === 'chosenCenterNotBooked' ? 'ReportChildren_LastViewedCenter' : 'ReportChildren_Center'),
			accessor: 'centerName',
			sortable: true
		},
		{
			header: t('ReportChildren_Count'),
			accessor: 'count',
			sortable: true
		}		
	];

	if (reportType === 'enrolledForTrialLesson') {
		columns.push({
			header: t('ReportChildren_ConversionRate'),
			accessor: 'conversionRate',
			cell: (conversionRate, row) => `${ui.formatAmount(conversionRate)}%`,
			sortable: false
		})
	}

	return (
		<Panel>
			{title && <Panel.Heading>{title}</Panel.Heading>}
			<Panel.Body>
				<PagedEntitiesList columns={columns} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(Summary);